import { SetOptional } from 'type-fest';

import { FilePlus02Icon } from '@/components/icons/FilePlus02Icon';
import {
  MenuItem,
  MenuItemProps,
} from '@/components/poppers/MenuPopper/MenuItem';
import { COLORS } from '@/styles/tokens/colors';

export function AddNewDocumentMenuItem(
  props: SetOptional<MenuItemProps, 'label'>
) {
  return (
    <MenuItem
      icon={<FilePlus02Icon size={16} sx={{ color: COLORS.TEXT.SECONDARY }} />}
      label="Upload a new document"
      {...props}
    />
  );
}
